import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { PartnersService } from 'src/app/api/collaborator/partners.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { constants } from 'src/app/constants';
import { CollaboratorsService } from 'src/app/api/collaborator/collaborators.service';
import { ToolsService } from 'src/app/utils/tools.service';

@Component({
  selector: 'app-collaborators-form',
  templateUrl: './collaborators-form.component.html',
  styleUrls: ['./collaborators-form.component.css']
})
export class CollaboratorsFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables =======
  typesdocument: any = [];
  partners: any = [];
  vehicletypes: any = [];
  statusmarital: any = [];
  sexs: any = [];
  // set values variables
  typeClientNatural: any = constants.CLIENT.TYPE[0];
  documentDni: any = constants.CLIENT.TYPE_DOCUMENT.DNI;
  documentRuc: any = constants.CLIENT.TYPE_DOCUMENT.RUC;
  typeDocumentSelected: any = null;

  service_alert: any = {
    class: 'success',
    message: '',
    show: false
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private generalService: GeneralService,
    private globalService: GlobalService,
    private partnersService: PartnersService,
    private collaboratorsService: CollaboratorsService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      partnercompany_id: [null, [Validators.required]],
      typedocument_id: [this.documentDni.id, [Validators.required]],
      vehicletype_id: [null],
      document: [null, [Validators.required]],
      fullname: [null, [Validators.required, Validators.minLength(2)]],
      cellphone: [null],
      email: [null, [Validators.email]],
      address: [null],
      date_birthday: [null],
      status: [null],
      sex: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    this.getTypeDocument();
    this.getPartners();
    this.getVehicleType();
    this.getStatusMarital();
    this.getSexs();
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.collaboratorsService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          partnercompany_id: item_.partnercompany_id,
          typedocument_id: item_.typedocument_id,
          vehicletype_id: item_.vehicletype_id,
          document: item_.document,
          fullname: item_.fullname,
          cellphone: item_.cellphone,
          email: item_.email,
          address: item_.email,
          date_birthday: item_.date_birthday,
          status: item_.status,
          sex: item_.sex,
        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getPartners() {
    this.partnersService.all().subscribe({
      next: (data: any) => {
        this.partners = data.results;
      }
    });
  }

  getVehicleType() {
    this.generalService.listVehicleType().subscribe({
      next: (data: any) => {
        this.vehicletypes = data.results;
      }
    });
  }

  getStatusMarital() {
    this.generalService.listStatusMarital().subscribe({
      next: (data: any) => {
        this.statusmarital = data;
      }
    });
  }

  getSexs() {
    this.generalService.listSexs().subscribe({
      next: (data: any) => {
        this.sexs = data;
      }
    });
  }

  getTypeDocument() {
    this.generalService.listTypeDocument().subscribe({
      next: (data: any) => {
        this.typesdocument = data;
        this.changeTypeDocument();
      }
    });
  }

  changeTypeDocument() {
    this.typeDocumentSelected = this.toolsService.searchArrById(
      this.item.value.typedocument_id,
      this.typesdocument
    );
  }

  extractDni() {
    let param_ = this.item.value.document;
    if (!_.isEmpty(param_)) {
      this.generalService.extractDni(param_).subscribe({
        next: (data: any) => {
          if (data.success) {
            this.replaceExtractDataDni(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataDni(data: any) {
    this.item.patchValue({
      fullname: data.fullname,
      address: data.address
    });
  }

  extractRuc() {
    let param_ = this.item.value.document;
    if (param_ != null) {
      this.generalService.extractRuc(param_).subscribe({
        next: (data: any) => {
          if(data.success){
            this.replaceExtractDataRuc(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          }else{
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataRuc(data: any) {
    this.item.patchValue({
      fullname: data.name,
      address: data.address
    });

    this.service_alert.class = data.alert_status;
    this.service_alert.message = "El cliente se encuentra con estado "+data.status +" y en condición " +data.condition;
    this.service_alert.show = true;    
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      if (this.isEdit) {
        this.collaboratorsService.update(this.checkId, this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.collaboratorsService.save(this.item.value).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/colaborador/colaboradores/lista'
    ]);
  }
}
